// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgLocation24 = forwardRef(
	({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
		let ariaLabelledBy = titleid ? titleid : "";
		ariaLabelledBy += desc && descid ? ` ${descid}` : "";
		ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
		props["aria-labelledby"] = ariaLabelledBy;
		return (
			<Svg
				width={size}
				height={size}
				viewBox="0 0 24 24"
				xmlns="http://www.w3.org/2000/svg"
				title={title}
				titleid={titleid}
				desc={desc}
				descid={descid}
				aria-labelledby={ariaLabelledBy}
				aria-hidden={!ariaLabelledBy}
				ref={ref}
				{...props}
			>
				{!!title && <title id={titleId}>{title}</title>}
				{!!desc && <desc id={descId}>{desc}</desc>}
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M12.8 4.24052L12.8 2H11.2L11.199 4.24063C7.53082 4.61482 4.61482 7.53082 4.24063 11.199L2 11.2V12.8L4.24052 12.8C4.61429 16.4686 7.53049 19.3851 11.199 19.7594L11.2 22H12.8L12.8 19.7595C16.469 19.3857 19.3857 16.469 19.7595 12.8L22 12.8V11.2L19.7594 11.199C19.3851 7.53049 16.4686 4.61429 12.8 4.24052ZM5.8 12C5.8 8.57583 8.57583 5.8 12 5.8C15.4242 5.8 18.2 8.57583 18.2 12C18.2 15.4242 15.4242 18.2 12 18.2C8.57583 18.2 5.8 15.4242 5.8 12ZM12 8.2C14.0987 8.2 15.8 9.90132 15.8 12C15.8 14.0987 14.0987 15.8 12 15.8C9.90132 15.8 8.2 14.0987 8.2 12C8.2 9.90132 9.90132 8.2 12 8.2ZM9.8 12C9.8 10.785 10.785 9.8 12 9.8C13.215 9.8 14.2 10.785 14.2 12C14.2 13.215 13.215 14.2 12 14.2C10.785 14.2 9.8 13.215 9.8 12Z"
				/>
			</Svg>
		);
	}
);
SvgLocation24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgLocation24;
